<ng-template vshczDisplacerPortal>
  <ng-content></ng-content>
</ng-template>
